import React, { Component } from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Paper from '@material-ui/core/Paper';
import './branch.css';
import Edit from './edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import Add from './add';
import { Button, Icon, Grid } from 'semantic-ui-react'
import View from './view';
import ReadCookie from '../../../functions/readcookies';

class Customer extends Component {

  state = {
    data: [],
    load: false,
    message: '',
    editDialog: false,
    deleteDialog: false,
    adddialog: false,
  }

  componentDidMount() {
    this.getBranch();
  }

  getBranch() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Branch Details'
    })
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'addmenu/modeldetails/get.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            load: false,
            data: data
          });
        } catch (e) {
          console.log(e);
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleClose = () => {
   this.setState({ editDialog: false, deleteDialog: false, adddialog: false });
  };

  edit(model_name, status, id, image_name, tamil_name, priority) {
    this.setState({
      model_name: model_name,
      tamil_name: tamil_name,
      status: status,
      id: id,
      editDialog: true,
      image_name: image_name,
      priority: priority
    })
  }

  updateData(data) {
    this.setState({
      data: data,
      editDialog: false
    })
  }

  updateDatas() {
    this.getBranch();
    this.setState({
      adddialog: false
    })
  }

  removeBranchDetails() {
    let context = this;
    context.setState({
      load: true,
      message: 'Deleting Model Details'
    })
    let data1 = {'id': this.state.deleteid};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/modeldetails/delete.php',
      success: function(data)
      {
        context.setState({
          load: false,
          deleteDialog: false,
        })
        if (data == 1) {
          context.update(context.state.deleteid);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  delete(id) {
    this.setState({
      deleteid: id,
      deleteDialog: true
    })
  }

  add() {
    this.setState({
      adddialog: true,
    })
  }

  update(id) {
    let data = this.state.data;
    let dele = [];
    data.map((del) => {
      if (del.id == id) {
        return;
      }
      else {
        dele.push(del);
      }
    });
    this.setState({
      data: dele,
    })
  }

  render() {
    const { fullScreen } = this.props;
    const { load, data, message, editDialog, adddialog, deleteDialog } = this.state;
    return (
      <div style={{padding: '1%', display: this.state.modelview}}>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={13}>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={3}>
            <br/>
            { this.props.menuPermission.add ?
              <Button fluid primary onClick={this.add.bind(this)} style={{display: this.state.modeledit}} icon labelPosition='left'>
                <Icon name='plus' />
                Add Model
              </Button>:''
            }
            
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <table width='100%' id='table'>
              <tr>
                <th id='tablehead' style={{width: '8%'}}>S.No</th>
                <th id='tablehead' style={{width: '18%'}}>Model Name</th>
                <th id='tablehead' style={{width: '18%'}}>Tamil Name</th>
                <th id='tablehead' style={{width: '8%'}}>Image</th>
                <th id='tablehead' style={{width: '10%'}}>Status</th>
                <th id='tablehead' style={{width: '6%'}}>Priority</th>
                { this.props.menuPermission.edit ?
                  <th id='tablehead' style={{width: '10%'}}>Edit</th>: ''}
                { this.props.menuPermission.cancel ?
                  <th id='tablehead' style={{width: '10%'}}>Delete</th>: ''}
              </tr>
              {data.map(row => (
                <tr id='rowselect'>
                  <td style={{fontSize: 14}}><center>{row.sino}</center></td>
                  <td style={{fontSize: 14}}><center>{row.model_name}</center></td>
                  <td style={{fontSize: 14}}><center>{row.tamil_name}</center></td>
                  <td><View menuPermission={this.props.menuPermission} image={row.image} modeledit={this.state.modeledit} modelId={row.id} image_name={row.image_name} /></td>
                  <td style={{fontSize: 14}}><center>{row.status}</center></td>
                  <td style={{fontSize: 14}}><center>{row.priority}</center></td>
                  { this.props.menuPermission.edit ?
                    <td onClick={this.edit.bind(this, row.model_name, row.status, row.id, row.image_name,
                                                      row.tamil_name, row.priority)}
                        style={{cursor: 'pointer', display: this.state.modeledit}}>
                      <center>Edit</center>
                    </td>:''}
                  { this.props.menuPermission.cancel ?
                  <td style={{cursor: 'pointer', display: this.state.modeledit}}
                      onClick={this.delete.bind(this, row.id)}>
                    <center>Delete</center>
                  </td>: ''}
                </tr>
              ))}
            </table>
          </Grid.Column>
        </Grid>

        <Dialog fullScreen={fullScreen} open={editDialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Edit Model"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Edit model_name ={this.state.model_name} status={this.state.status}
                    updateData={this.updateData.bind(this)} data={this.state.data}
                    priority={this.state.priority}
                    handleClose={this.handleClose} id={this.state.id}
                    image_name={this.state.image_name} tamil_name={this.state.tamil_name}/>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen={fullScreen} open={adddialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>
            {"Add Model"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Add updateDatas={this.updateDatas.bind(this)} handleClose={this.handleClose}/>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog fullScreen={fullScreen} open={deleteDialog}
          onClose={this.handleClose} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 100}}>
            {"Delete Model"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>Do you want to remove it!!</div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.handleClose.bind(this)} color="secondary">
              NO
            </Buttons>
            <Buttons onClick={this.removeBranchDetails.bind(this)} color="primary" autoFocus>
              Yes
            </Buttons>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Customer;
